import PropTypes from 'prop-types'
import React from 'react'

export const AdDetailsImage = ({ img, className, onClick, title }) => {
  return (
    <div className={className}>
      <a href='javascript:void(0)' onClick={onClick}>{'\n'}
        <div
          className={'oglas-item-slika detail'}
          style={{ position: 'relative' }}
        >
          {/* <Image src={img} alt={title} layout='fill' objectFit='cover' /> */}
          <img src={img} alt={title} style={{ objectFit: 'cover' }} />
        </div>
      </a>
    </div>
  )
}

AdDetailsImage.propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func
}
